// Sticky add to cart.
//
// In the theme: assets/nextdev-pdp-sticky-atc.js, loaded by
// snippets/nextdev-pdp-sticky-atc.liquid.
//
// It reads the section rather than keeping a copy of its own: the name, the
// chosen options, the price and the struck price, the chosen variant's
// picture, and whether the section's button can add. The section's own script
// writes all of those, and a MutationObserver hears every write, so the bar
// can never say something the section does not. Every button in it presses
// the section's own: an option picks it there, the size guide opens the
// section's, and the add to cart posts the section's form, so the offer and
// anything tied to the form go in exactly as they would from there.
(function () {
  document.querySelectorAll('[data-nextdev-sticky-atc]').forEach(function (bar) {
    if (bar.dataset.nextdevStickyAtcInit) return;
    bar.dataset.nextdevStickyAtcInit = '1';

    // the section the bar was rendered in, read before the bar moves out of it
    var root = bar.closest('[data-nextdev-pdp]');
    if (!root) return;
    var atc = root.querySelector('[data-nextdev-pdp-atc]');
    if (!atc) return;

    var scrim = root.querySelector('[data-nextdev-sticky-atc-scrim]');
    var room = root.querySelector('[data-nextdev-sticky-atc-room]');

    // The bar, its scrim and its room go to the end of <body>. A fixed box
    // under an ancestor with a transform is fixed to that ancestor rather
    // than to the screen, and a theme's own section wrapper can carry one;
    // the room belongs at the foot of the page, not under this section; and
    // a bar outside the section is not heard by the observer below when it
    // writes to itself. A bar left behind by an earlier render of the same
    // section, in the theme editor, is taken away first.
    var key = root.closest('[id^="shopify-section-"]');
    key = key ? key.id : '';
    if (key) {
      document.querySelectorAll('body > [data-nextdev-sticky-atc-for="' + key + '"]').forEach(function (old) {
        old.parentNode.removeChild(old);
      });
    }
    [scrim, bar, room].forEach(function (el) {
      if (!el) return;
      if (key) el.setAttribute('data-nextdev-sticky-atc-for', key);
      document.body.appendChild(el);
    });

    var q = function (sel) { return bar.querySelector(sel); };
    var thumb = q('[data-nextdev-sticky-atc-thumb]');
    var title = q('[data-nextdev-sticky-atc-title]');
    var closeButton = q('[data-nextdev-sticky-atc-close]');
    var variantLine = q('[data-nextdev-sticky-atc-variant]');
    var was = q('[data-nextdev-sticky-atc-was]');
    var now = q('[data-nextdev-sticky-atc-now]');
    var button = q('[data-nextdev-sticky-atc-button]');
    var options = q('[data-nextdev-sticky-atc-options]');
    var panelTitle = q('[data-nextdev-sticky-atc-panel-title]');

    var pageTitle = root.querySelector('.nextdev--pdp__title');
    var pagePrice = root.querySelector('[data-nextdev-price]');
    var pageCompare = root.querySelector('[data-nextdev-price-compare]');
    var atcText = root.querySelector('[data-nextdev-atc-text]');
    var soldOut = atc.querySelector('.sold-out-message');
    var idInput = root.querySelector('[data-nextdev-variant-id]');
    var pageGroups = Array.prototype.slice.call(root.querySelectorAll('[data-nextdev-pdp-option-group]'));

    var variants = [];
    var variantsEl = root.querySelector('[data-nextdev-variants]');
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) { variants = []; }
    }

    function text(el) {
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    function make(tag, cls) {
      var el = document.createElement(tag);
      if (cls) el.className = cls;
      return el;
    }

    // a click the bar hands on to the section is still the bar's own click,
    // so the listener that closes the panel on a click off the bar lets it by
    var handing = false;

    function press(el) {
      handing = true;
      try { el.click(); } finally { handing = false; }
    }

    // ---- the options, drawn once from the section's own buttons ----
    // one group per option the section draws, in its order and under its
    // name; each button is paired with the section's button it stands for,
    // and a click on it is a click on that one
    var pairs = [];
    var groups = [];

    pageGroups.forEach(function (pageGroup, i) {
      var pageButtons = Array.prototype.slice.call(pageGroup.querySelectorAll('[data-nextdev-pdp-option]'));
      if (!pageButtons.length) return;

      var name = pageGroup.getAttribute('data-option-name') || '';
      var swatches = pageButtons[0].classList.contains('nextdev--pdp__color');

      if (groups.length) {
        var divider = make('span', 'nextdev--pdp__sticky-atc-divider');
        divider.setAttribute('aria-hidden', 'true');
        options.appendChild(divider);
      }

      var group = make('div', 'nextdev--pdp__sticky-atc-group');
      var head = make('div', 'nextdev--pdp__sticky-atc-head');
      var label = make('span', 'nextdev--pdp__sticky-atc-label');
      label.appendChild(document.createTextNode(name));
      var labelValue = make('span', 'nextdev--pdp__sticky-atc-label-value');
      labelValue.appendChild(document.createTextNode(': '));
      var valueName = make('strong');
      labelValue.appendChild(valueName);
      label.appendChild(labelValue);
      head.appendChild(label);

      // the size guide sits in the group the section put it in, and no other
      var pageGuide = pageGroup.querySelector('[data-nextdev-pdp-size-guide]');
      if (pageGuide) {
        var guide = make('button', 'nextdev--pdp__sticky-atc-guide');
        guide.type = 'button';
        guide.textContent = text(pageGuide);
        guide.addEventListener('click', function () { press(pageGuide); });
        head.appendChild(guide);
      }
      group.appendChild(head);

      var list = make('div', swatches ? 'nextdev--pdp__sticky-atc-swatches' : 'nextdev--pdp__sticky-atc-sizes');
      list.setAttribute('role', 'group');
      list.setAttribute('aria-label', name);

      pageButtons.forEach(function (page) {
        var value = page.getAttribute('data-value') || text(page);
        var b = make('button', swatches ? 'nextdev--pdp__sticky-atc-swatch' : 'nextdev--pdp__sticky-atc-size');
        b.type = 'button';
        if (swatches) {
          b.setAttribute('aria-label', value);
          var pic = page.querySelector('img');
          var paint = page.querySelector('.nextdev--pdp__swatch');
          if (pic) {
            var img = make('img');
            img.src = pic.getAttribute('src');
            img.alt = '';
            img.width = 36;
            img.height = 36;
            img.loading = 'lazy';
            b.appendChild(img);
          } else if (paint) {
            // a swatch the shop set as a colour is painted by a <style> the
            // section writes against its own button, so the colour is read
            // off that and handed to ours
            var color = make('span', 'nextdev--pdp__sticky-atc-swatch-color');
            color.style.setProperty('--nextdev-sticky-atc-swatch', getComputedStyle(paint).backgroundColor);
            b.appendChild(color);
          }
        } else {
          b.textContent = value;
        }
        b.addEventListener('click', function () {
          press(page);
          setTimeout(sync, 0);
        });
        list.appendChild(b);
        pairs.push({ ours: b, theirs: page, kind: swatches ? 'swatch' : 'size' });
      });

      group.appendChild(list);
      options.appendChild(group);
      groups.push({ name: name, value: valueName, page: pageGroup.querySelector('[data-nextdev-pdp-option-value]') });
    });

    // a product with one variant has nothing to choose, so nothing opens and
    // the button only ever adds
    var choosable = groups.length > 0;
    if (!choosable) options.hidden = true;

    // an open panel with one option is shorter than one with two, and the
    // chat button that climbs clear of it reads this off the page, in the css
    document.documentElement.classList.toggle('nextdev--pdp__sticky-atc-one-option', groups.length === 1);

    // The label before the options are open names the options the bar
    // really draws, in lower case and in the section's order: "size",
    // "size & color", "size, colour & firmness". `[options]` in the label
    // the section hands over is where the list goes.
    var names = groups.map(function (g) { return g.name.toLowerCase(); });
    var list = names.length > 1
      ? names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1]
      : names.join('');
    var template = bar.getAttribute('data-choose-label') || 'Choose [options]';
    var CHOOSE = template.replace('[options]', list);
    if (panelTitle) panelTitle.textContent = CHOOSE;
    options.setAttribute('aria-label', CHOOSE);

    // Under 1024 the options are a panel over the bar, and the button is the
    // choose label until the panel is open, when it becomes the add to cart.
    // From 1024 up they sit in the row and the button only adds.
    var wide = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };

    function isOpen() {
      return bar.classList.contains('nextdev--pdp__sticky-atc--open');
    }

    function choosing() {
      return choosable && !wide.matches && !isOpen();
    }

    // ---- open and closed, for the widths where the options are a panel ----
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var opening = null;

    function open(on) {
      var before = isOpen();
      bar.classList.toggle('nextdev--pdp__sticky-atc--open', on);
      // the page steps back behind a panel, which only a narrow screen has
      var behind = on && !wide.matches;
      if (scrim) scrim.classList.toggle('nextdev--pdp__sticky-atc-scrim--visible', behind);
      document.documentElement.classList.toggle('nextdev--pdp__sticky-atc-locked', behind);
      sync();
      if (on && !before) grow();
      // closing is instant, on the owner's call: nothing is left running
      if (!on && opening) {
        opening.cancel();
        opening = null;
      }
    }

    // The panel opens by growing up out of the bar: its height, its padding
    // and its gap to the row run from nothing to what they are, while the
    // options fade and rise into place. Worked out from the panel as it is
    // drawn, so any number of options opens to its own height.
    function grow() {
      if (wide.matches || (reduced && reduced.matches) || !options.animate) return;
      var cs = getComputedStyle(options);
      var full = {
        maxHeight: options.scrollHeight + 'px',
        paddingTop: cs.paddingTop,
        paddingBottom: cs.paddingBottom,
        marginBottom: cs.marginBottom,
        opacity: 1,
        transform: 'translateY(0)',
        overflow: 'hidden'
      };
      opening = options.animate([
        { maxHeight: '0px', paddingTop: '0px', paddingBottom: '0px', marginBottom: '0px', opacity: 0, transform: 'translateY(12px)', overflow: 'hidden' },
        full
      ], { duration: 320, easing: 'cubic-bezier(.2, .8, .2, 1)' });
      opening.onfinish = function () { opening = null; };
    }

    closeButton.addEventListener('click', function () {
      open(false);
      button.focus();
    });

    function guideOpen() {
      return !!document.querySelector('.nextdev--size-guide__modal:not(.nextdev--size-guide__modal--hidden)');
    }

    // escape closes the panel, unless the size guide is open over it: then
    // escape is the guide's, and the panel is still there when it closes.
    // Heard on the way down, before the guide's own listener has closed it.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen() || guideOpen()) return;
      open(false);
      button.focus();
    }, true);

    // a click anywhere off the bar closes the panel, the size guide aside,
    // which opens over it and comes back to it
    document.addEventListener('click', function (e) {
      if (handing || !isOpen()) return;
      if (bar.contains(e.target)) return;
      if (e.target.closest && e.target.closest('.nextdev--size-guide__modal')) return;
      open(false);
    });

    // ---- keeping the bar in step with the section ----
    // The product's own variant, which the section publishes, rather than
    // the id the form posts: the bundle can post another product's variant,
    // and the picture follows this product's, the way the gallery does.
    function currentVariant() {
      if (typeof root.nextdevPdpVariant === 'function') {
        var v = root.nextdevPdpVariant();
        if (v) return v;
      }
      var id = idInput ? String(idInput.value) : '';
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) return variants[i];
      }
      return null;
    }

    // the chosen variant's own picture, the one its media id names in the
    // gallery, and the gallery's first shown one where it names none
    function picture() {
      var v = currentVariant();
      var mediaId = v && v.featured_media && v.featured_media.id;
      var img = mediaId
        ? root.querySelector('[data-nextdev-pdp-slide][data-media-id="' + mediaId + '"] img')
        : null;
      if (!img) img = root.querySelector('[data-nextdev-pdp-slide]:not([hidden]) img');
      return img ? (img.currentSrc || img.getAttribute('src')) : '';
    }

    function unavailable(el) {
      return el.disabled
        || el.getAttribute('aria-disabled') === 'true'
        || /--unavailable\b/.test(el.className);
    }

    // what the section's own button says right now: its label while it adds,
    // and its sold out line when it does not
    function atcLabel() {
      if (atcText && !atcText.classList.contains('hidden')) return text(atcText);
      if (soldOut && !soldOut.classList.contains('hidden')) return text(soldOut);
      return text(atcText) || 'Add to cart';
    }

    function sync() {
      var chosen = [];
      groups.forEach(function (g) {
        var value = text(g.page);
        g.value.textContent = value;
        if (value) chosen.push(value);
      });
      variantLine.textContent = chosen.join(' / ');

      if (pageTitle) title.textContent = text(pageTitle);

      if (pagePrice) now.textContent = text(pagePrice);
      if (pageCompare) {
        var struck = pageCompare.hidden ? '' : text(pageCompare);
        was.textContent = struck;
        was.hidden = !struck;
      }

      var src = picture();
      if (thumb && src && thumb.getAttribute('src') !== src) thumb.setAttribute('src', src);

      pairs.forEach(function (p) {
        var picked = /--selected\b/.test(p.theirs.className);
        p.ours.classList.toggle('nextdev--pdp__sticky-atc-' + p.kind + '--selected', picked);
        p.ours.classList.toggle('nextdev--pdp__sticky-atc-' + p.kind + '--unavailable', unavailable(p.theirs));
        p.ours.setAttribute('aria-pressed', picked ? 'true' : 'false');
      });

      // Closed on a narrow screen it only opens the panel, so it is never
      // off: a sold out variant is exactly when a visitor wants another.
      // Otherwise it gives the section's button's answer: sold out reads sold
      // out.
      if (choosing()) {
        button.disabled = false;
        button.textContent = CHOOSE;
        button.setAttribute('aria-expanded', 'false');
      } else {
        button.disabled = atc.disabled || atc.getAttribute('aria-disabled') === 'true';
        button.textContent = atcLabel();
        if (choosable && !wide.matches) button.setAttribute('aria-expanded', 'true');
        else button.removeAttribute('aria-expanded');
      }
    }

    // the room at the foot of the page is the closed bar's height, so an open
    // panel lies over the page rather than pushing it about
    // The page carries the height as well, so what else sits at the foot of
    // the screen (the who-likes pop-up, in the css) can stand over the bar.
    function measure() {
      if (!room || isOpen()) return;
      room.style.setProperty('--nextdev-sticky-atc-room', bar.offsetHeight + 'px');
      document.documentElement.style.setProperty('--nextdev-sticky-atc-height', bar.offsetHeight + 'px');
    }

    // The room comes after the footer, so it takes the footer's colour and the
    // foot of the page reads as the footer running on, not as a strip of the
    // page's own ground. The colour is read off the page rather than named
    // here, so a footer given another colour takes the room with it. The
    // first box in the footer that paints a colour is the footer's; a page
    // with no footer leaves the room as it was.
    function paintRoom() {
      if (!room) return;
      var groups = document.querySelectorAll('.shopify-section-group-footer-group');
      var footer = groups.length ? groups[groups.length - 1] : null;
      var colour = '';
      if (footer) {
        var boxes = [footer].concat(Array.prototype.slice.call(footer.querySelectorAll('footer, div')));
        for (var i = 0; i < boxes.length && i < 12; i += 1) {
          var paint = window.getComputedStyle(boxes[i]).backgroundColor;
          if (paint && paint !== 'transparent' && paint !== 'rgba(0, 0, 0, 0)') {
            colour = paint;
            break;
          }
        }
      }
      room.style.backgroundColor = colour;
    }

    // the footer's stylesheet can land after this runs, and the theme editor
    // draws the footer again after a change to it
    window.addEventListener('load', paintRoom);
    document.addEventListener('shopify:section:load', paintRoom);

    // The page says whether the bar is up, so what else sits at the foot of
    // the screen can make room: the Gorgias chat button lifts over it, in the
    // css. The page class only marks a page that has a bar at all, so the
    // chat button's own motion is left alone everywhere else.
    document.documentElement.classList.add('nextdev--pdp__sticky-atc-page');

    // forGuide: the bar steps aside for the size guide rather than for the
    // page. An open panel is then left open under the guide, and the focus is
    // left where the guide put it, so closing the guide finds the bar as it was.
    function show(on, forGuide) {
      bar.classList.toggle('nextdev--pdp__sticky-atc--hidden', !on);
      document.documentElement.classList.toggle('nextdev--pdp__sticky-atc-shown', on);
      if (on) {
        bar.removeAttribute('aria-hidden');
        bar.removeAttribute('inert');
      } else {
        if (isOpen() && !forGuide) open(false);
        // a focus inside a bar that is going away goes back to the section's
        // own button rather than to nowhere
        if (!forGuide && bar.contains(document.activeElement)) atc.focus({ preventScroll: true });
        bar.setAttribute('aria-hidden', 'true');
        bar.setAttribute('inert', '');
      }
      // The scrim goes with the bar. It sits at the end of <body>, over the
      // size guide, which lives in the section: left up while the bar steps
      // aside for the guide, it covered the guide until a tap closed the
      // panel. It comes back with the bar if the panel is still open.
      if (scrim) {
        scrim.classList.toggle('nextdev--pdp__sticky-atc-scrim--visible', on && isOpen() && !wide.matches);
      }
    }

    // shown only once the section's button has gone up past the top: above
    // it, on the way down, the visitor has not reached it yet. Never while
    // the size guide is open: the bar steps aside for it and comes back when
    // it closes.
    function decide() {
      var guide = guideOpen();
      show(atc.getBoundingClientRect().bottom < 0 && !guide, guide);
    }

    // the size guide opens and closes by a class on its modal, and nothing
    // scrolls when it does, so the bar is told by watching that class
    document.querySelectorAll('.nextdev--size-guide__modal').forEach(function (modal) {
      new MutationObserver(decide).observe(modal, { attributes: true, attributeFilter: ['class'] });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(decide).observe(atc);
    }
    window.addEventListener('scroll', decide, { passive: true });
    window.addEventListener('resize', function () { measure(); decide(); });

    new MutationObserver(sync).observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'disabled', 'aria-disabled', 'value']
    });
    // the id is a hidden field, and a script setting its value writes no
    // attribute, so a change of variant is also heard where it is announced
    root.addEventListener('nextdev:pdp:variant', function () { setTimeout(sync, 0); });
    root.addEventListener('click', function () { setTimeout(sync, 0); });

    button.addEventListener('click', function () {
      if (button.disabled) return;
      if (choosing()) {
        open(true);
        return;
      }
      open(false);
      press(atc);
    });

    // Opened from elsewhere on the page: a button in image with text that has
    // no link of its own asks for the options here under 1024, rather than
    // sending the visitor all the way back up to the section's picker. It
    // answers whether it opened, so the caller can do something else where it
    // cannot: the bar is not up yet (the section's button is still on
    // screen), the product has nothing to choose, or the screen is wide
    // enough that the options sit in the row and there is no panel to open.
    // The click that asked is still on its way up to the document, where the
    // listener that closes the panel on a click off the bar would hear it and
    // shut it again, so the panel opens once that click is done.
    bar.nextdevStickyAtcOpen = function () {
      if (!choosable || wide.matches) return false;
      if (bar.classList.contains('nextdev--pdp__sticky-atc--hidden')) return false;
      setTimeout(function () {
        if (isOpen()) return;
        open(true);
        // the focus goes where the open panel's own close puts it back to,
        // so a keyboard lands in the bar rather than behind the scrim
        button.focus({ preventScroll: true });
      }, 0);
      return true;
    };

    // crossing 1024 changes what the button is, and an open panel means
    // nothing where the options already sit in the row
    if (wide.addEventListener) {
      wide.addEventListener('change', function () { open(false); measure(); });
    }

    if (room) room.hidden = false;
    sync();
    measure();
    paintRoom();
    decide();
  });
})();
